/** Intervalo compartido para cabeza de cadena (ApplicationUpdater / wagmi). */
export const BLOCK_HEAD_POLL_INTERVAL_MS = 12_000

/** Polling por defecto de wagmi (`getDefaultConfig`). */
export const WAGMI_DEFAULT_POLLING_INTERVAL_MS = 12_000

/** MulticallUpdater: balances, reservas, allowances. */
export const MULTICALL_POLL_VOLATILE_MS = 8_000

/** MulticallUpdater: solo listeners `NEVER_RELOAD` (metadata token, etc.). */
export const MULTICALL_POLL_STATIC_MS = 60_000

/** Ventana de agregación de contadores `[RPC_TRAFFIC]` en consola. */
export const RPC_TRAFFIC_LOG_INTERVAL_MS = 60_000
